define("shared/utils/update-intercom", ["exports", "@ember/debug", "later/utils/time-format"], function (_exports, _debug, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"later/utils/time-format"eaimeta@70e063a35619d71f

  const defaultFields = {
    last_request_at: parseInt((0, _timeFormat.timestamp)())
  };
  /**
   * Calling the update method with some new user data will trigger the
   * JavaScript to look for new messages that should be displayed to the current user.
   * See https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomupdate
   *
   * @method updateIntercom
   * @param {Object} [updatedFields=defaultFields] intercom fields to update
   *
   */

  const updateIntercom = function () {
    let updatedFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFields;
    (false && !(typeof updatedFields === 'object') && (0, _debug.assert)('updatedFields must either be of type Object', typeof updatedFields === 'object'));

    if (window.Intercom) {
      window.Intercom('update', updatedFields);
    }
  };

  var _default = updateIntercom;
  _exports.default = _default;
});